import { Button } from '@shared/components';
import { PiSidebarSimple } from 'react-icons/pi';

type ThreadListToggleProps = {
  isThreadListCollapsed: boolean;
  onToggle: () => void;
};

export function ThreadListToggle({
  isThreadListCollapsed,
  onToggle,
}: ThreadListToggleProps) {
  const label = isThreadListCollapsed ? 'Show chats' : 'Hide chats';
  return (
    <Button
      aria-label={label}
      isGhost
      icon={<PiSidebarSimple size={16} />}
      onPress={onToggle}
      size="xs"
      tooltip={label}
    />
  );
}
